import { render, staticRenderFns } from "./CarouselVsupport.vue?vue&type=template&id=0f29419c"
import script from "./CarouselVsupport.vue?vue&type=script&lang=js"
export * from "./CarouselVsupport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports